export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false,
            show_reset_button: false,
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn-danger my-custom-class",
                event_payload: 'search'
            },
        ],
        searchFields: [
            {
                name: "doctorName",
                label: "Orvos",
                formSize: 6,
                formType: 'text',
                formReadOnly: true,
            },
            {
                name: "date",
                label: "Dátum",
                formSize: 6,
                formType: 'date'
            },
        ],
        headerFields: [
            {
                name: "doctorFullName",
                label: "Orvos",
                visibility: true,
                formType: 'text',
            },
            {
                name: "appointment",
                label: "Időpont",
                sort: true,
                visibility: true,
                slot_name: "appointment_format",
                formType: 'date',
            },
            {
                name: "patient.name",
                label: "Név",
                sort: true,
                formVisible: true,
                slot_name: "patientNameFormat"
            },
            {
                name: "patient.socialInsuranceNumber",
                label: "TAJ",
                visibility: true,
            },
            {
                name: "patient.dateOfBirth",
                label: "Születés dátuma",
                visibility: true,
                slot_name: "date_format",
            },
            {
                name: "contact.text",
                label: "Beküldő",
                visibility: true,
                slot_name: "isContactPartner",
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: true,
                slot_name: "preTagFormat",
            },
            {
                name: "treatmentTitle",
                label: "Kezelés",
                visibility: true,
                formType: 'text',
            },
            {
                name: "codedTreatments",
                label: "Felkódolt kezelések",
                visibility: true,
                slot_name: "rowBreakAtComa",
            },
        ]
    }
}
